import merge from 'lodash/merge'
import { parseResponsiveProperty } from '@converdy/styles'

export default ({
  emptyColor,
  filledColor,
  spacing,
  size
}) => {

  let jss = {

    '&': {
      color: emptyColor,
      ...merge(
        parseResponsiveProperty(v => {
          return v ? {
            '--size': `${v}px`,
          } : {} 
        }, size),
        parseResponsiveProperty(v => {
          return v ? {
            '--spacing': `${v}px`,
          } : {} 
        }, spacing)

      )
    },
    '& .icons-filled': {
      color: filledColor
    },
  }
    

  return jss
}